module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAoCAYAAAD6xArmAAAA1ElEQVRIS7XXuw0CMRAE0NmA4ggJCcmohxaIKIuAMtAio+PE6fzZz9gFPFmWtbMjmHSE5arqEcBt8a4UWFVPAB4ADgv8TMMVtNivFNxA3wDOYbiDXkTkHoJHaHkLN2xB3bAVdcEe1Ax7URMcQYdwFO3CGbQJZ9EqzEB3MAvdwEx0hdnoF56BzoWLPuPW69hk45t5zMR3g56FVxOEgTejKYt3My+DD8M0ig/h6D83wRHcDHtxF+zB3bAVD8EWPAwP8Pga+6sYUxbvDp6vCn84v9zUmtcHGMvayZhSVB8AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/icon_v2/return_white@2x.png
// module id = HLIZ
// module chunks = 1